import { RrRepository } from '../../core/repositories/rr_repository';
import { Item } from '../models/item';
import {isSoloare, JsEnv, SiteType} from '../../core/models/js_env';
import { ItemJsEnv } from '../models/item_js_env';
import { TypedEvent } from '../../core/typed_event';
import { createRrRequestParam } from '../models/rr/set_rr_request';
import { createRrModalRequestParam } from '../models/rr/set_rr_modal_request';
import { getRrAreaData } from '../../core/models/rr/rr_util';
import { ItemDetailRrContainer } from '../views/pc/item_detail_rr_container';
import { ItemDetailRrModalContainer } from '../views/pc/item_detail_rr_modal_container';
import { CatalogItemCodesWithElementId, doShowRtoaster, RtoasterParameter } from '../../core/models/rtoaster/rtoaster_utils';
import { setParametersCallBack } from '../models/rtoaster/set_rtoaster_parameter';
import { Env } from '../../core/env';
import { RTOASTER_STATUS } from '../../core/rtoaster';
import { setLoadingTimer, cancelLoading } from '../../core/util/dom_util';

const SUPPLIER_ID_ASKUL = 'P00001';
const MAX_RETRY_COUNT = 30;
const RETRY_INTERVAL = 100;

export class ItemDetailRrAction {
  static readonly UPDATE_EVENT = new TypedEvent<ItemJsEnv>();
  private static state: Item;
  private static rrRepository: RrRepository;

  static init(env: JsEnv) {
    this.state = new Item(env.PAGE);
    this.rrRepository = new RrRepository();
    const model = this.state.getModel();

    // おすすめ情報設定offの場合RR部分は実行しない
    if (!isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend) {
      // カゴ追加モーダルのレコメンドは常に表示する
      new ItemDetailRrModalContainer() // NOSONAR

      if (window['RR'] !== undefined) {
        if (model.isFromExternalSite) {
          // 外部流入レコメンドを表示する場合、ローディング中モジュールを表示させるため、
          // タイマーを設定する(RR応答遅延等を考慮し、タイマー満了時にローディングを解除)
          const timeoutId = setLoadingTimer(model.rrAreaProfileItemExternalSite.placementName);
          model.rrAreaProfileItemExternalSite.timeoutId = timeoutId;
        }
        window['RR'].jsonCallback = this.renderRr.bind(this);
        this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), false);
      }
    }

    // 下のRtoasterの分岐は削除予定なので独立させておく
    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend) {
        this.rrRepository.sendRequestToRrServer(createRrRequestParam(model), true);
    }

    if (isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && typeof Rtoaster !== 'undefined') {
      const elementIds = ['tr_recom_DAD02010_001', 'tr_recom_DAD02010_002', 'tr_recom_DAD02010_003'];

      const rtoasterParameter: RtoasterParameter = {
        appKeys: {ctgry1CdView: env.PAGE.categoryTree.llCategoryCode, ctgry2CdView: env.PAGE.categoryTree.lCategoryCode},
        catalogItemCode: SUPPLIER_ID_ASKUL + env.PAGE.catalogItemCode
      };

      // カゴ追加押下時のRtoasterAPI送信との競合をさけるため、処理中に更新
      RTOASTER_STATUS.isDuringRtoaster = true;
      doShowRtoaster({
        elementIds: elementIds,
        showRtoasterAreaCallBack: this.showRtoasterArea.bind(this),
        setParametersCallBack: setParametersCallBack,
        rtoasterParameter: rtoasterParameter
      })
    }
  }

  // init処理がDomLoad前にされるためDomLoad後に呼び出す用の処理
  static initAfterDomLoad(env: JsEnv) {
    const model = this.state.getModel();
    // おすすめ情報設定offの場合RR部分は実行しない
    if (!isSoloare(env.SITE_TYPE) && model.shouldDisplayRecommend && window['RR'] == undefined && model.isFromExternalSite) {
      // RR未定義の場合はRR送信しないため、ローディングモジュールを即解除
      cancelLoading(model.rrAreaProfileItemExternalSite.placementName);
    }
  }

  static addCartButtonRrRecommend(targetCatalogItemCode: string) {
    const model = this.state.getModel();

    // おすすめ情報設定offの場合RR部分は実行しない
    if (!isSoloare(Env.SITE_TYPE) && model.shouldDisplayRecommend && window['RR'] !== undefined) {
      // 商品詳細画面初期表示時のRRコールバック関数と、カゴ追加時のRRコールバック関数が
      // 競合してしまうため、商品詳細画面初期表示のコールバック処理中はカゴ追加を待ち合わせる
      let count = 0;
      const waitTimer = setInterval(() => {
        count++;
        if (typeof window['RR'].jsonCallback === 'undefined' || count > MAX_RETRY_COUNT) {
          clearInterval(waitTimer);
          window['RR'].jsonCallback = this.renderRrModal.bind(this);
          this.rrRepository.sendRequestToRrServer(createRrModalRequestParam(model, targetCatalogItemCode));
        }
      }, RETRY_INTERVAL);
    }
  }

  private static async showRtoasterArea(catalogItemCodesWithElementIds: CatalogItemCodesWithElementId[]) {
    const state = this.state;
    const model = state.getModel();

    if (model.isFromExternalSite) {
      const externalSiteCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_recom_DAD02010_002')[0].catalogItemCodes;
      const externalSiteCarouselItems = await this.rrRepository.getRrItemsDetail(externalSiteCatalogItemCodes, false, SiteType.SOLOARE);
      state.setRrAreaDataItemExternalSite(externalSiteCarouselItems, 'この商品を見たあとにこの商品が買われています');
    }

    const normalUpperCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_recom_DAD02010_003')[0].catalogItemCodes;
    const normalUpperCarouselItems = await this.rrRepository.getRrItemsDetail(normalUpperCatalogItemCodes, false, SiteType.SOLOARE);
    state.setRrAreaDataItemNormalUpper(normalUpperCarouselItems, 'この商品を見ている方はこんな商品にも興味をもっています');

    const normalLowerCatalogItemCodes = catalogItemCodesWithElementIds.filter(catalogItemCodesWithElementId => catalogItemCodesWithElementId.elementId === 'tr_recom_DAD02010_001')[0].catalogItemCodes;
    const normalLowerCarouselItems = await this.rrRepository.getRrItemsDetail(normalLowerCatalogItemCodes, false, SiteType.SOLOARE);
    state.setRrAreaDataItemNormalLower(normalLowerCarouselItems, 'この商品を買った人はこんな商品も買っています');

    // カゴ追加時のRtoasterAPI送信を可能とする
    RTOASTER_STATUS.isDuringRtoaster = false;
    return new ItemDetailRrContainer(model); // NOSONAR
  }

  private static async renderRr() {
    const state = this.state
    const model = state.getModel()

    if (model.isFromExternalSite) {
      // 外部流入時は外部流入版RRエリアも表示する
      const rrData = await Promise.all([
        getRrAreaData(model.rrAreaProfileItemNormalUpper),
        getRrAreaData(model.rrAreaProfileItemNormalLower),
        getRrAreaData(model.rrAreaProfileItemExternalSite),
      ]);

      state.setRrAreaDataItemNormalUpper(rrData[0].items, rrData[0].title);
      state.setRrAreaDataItemNormalLower(rrData[1].items, rrData[1].title);
      state.setRrAreaDataItemExternalSite(rrData[2].items, rrData[2].title);
    } else {
      const rrData = await Promise.all([
        getRrAreaData(model.rrAreaProfileItemNormalUpper),
        getRrAreaData(model.rrAreaProfileItemNormalLower),
      ]);

      state.setRrAreaDataItemNormalUpper(rrData[0].items, rrData[0].title);
      state.setRrAreaDataItemNormalLower(rrData[1].items, rrData[1].title);
    }

    // コールバックを初期化し、カゴ追加時のRR送信を可能とする
    window['RR'].jsonCallback = undefined;
    return new ItemDetailRrContainer(model);
  }

  private static async renderRrModal() {
    const state = this.state
    const model = state.getModel()
    const rrDataItemAddCartModal = await getRrAreaData(model.rrAreaProfileItemModal)
    state.setRrAreaDataItemModal(rrDataItemAddCartModal.items, rrDataItemAddCartModal.title);

    if (0 < rrDataItemAddCartModal.items.length) {
      this.UPDATE_EVENT.trigger(this.state.getModel());
    }
    // コールバックを初期化し、2回目以降のカゴ追加時のRR送信を可能とする
    window['RR'].jsonCallback = undefined;
  }
}
